import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdExternalApi = z.any()
export type TagsGetMunicipalities_municipalityIdExternalApi = z.infer<typeof tagsGetMunicipalities_municipalityIdExternalApi>

export const paramsGetMunicipalities_municipalityIdExternalApi = z.object({ "municipalityId": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdExternalApi = z.infer<typeof paramsGetMunicipalities_municipalityIdExternalApi>

export const responseGetMunicipalities_municipalityIdExternalApi = z.object({ "payload": z.array(z.object({ "id": z.string(), "providerName": z.string(), "clientId": z.string(), "apiKey": z.string().max(4), "createdAt": z.string().datetime({ offset: true }), "updatedAt": z.string().datetime({ offset: true }), "collectionPointIds": z.array(z.string()), "collectionPoints": z.array(z.object({ "id": z.string(), "name": z.string(), "identifier": z.string(), "type": z.string(), "buildingId": z.string(), "buildingName": z.string() })) })).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdExternalApi = z.infer<typeof responseGetMunicipalities_municipalityIdExternalApi>

interface IGetMunicipalities_municipalityIdExternalApi extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdExternalApi,
  params: ParamsGetMunicipalities_municipalityIdExternalApi,
  response: ResponseGetMunicipalities_municipalityIdExternalApi
}
export const URL = '/municipalities/:municipalityId/externalApi'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdExternalApi,
    params: paramsGetMunicipalities_municipalityIdExternalApi,
    response: responseGetMunicipalities_municipalityIdExternalApi
  }
}
export interface Municipalities_municipalityIdExternalApi extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdExternalApi
}